module.exports = __webpack_public_path__ + "img/bannerRed.2f63ae89.jpg";